import EventEmitter from 'mitt';
/**
 * A generic client for app-messager
 *
 * TODO implement on, off
 */
function WebSocketClient(url: string, messageHandler?: string) {
    this._url       = url;
    this._active    = true;
    this._ws        = null;
    this._handler   = messageHandler;
    this._delay     = 0;
    this._apiKey    = null;
    this._eventLoop = new EventEmitter();
}

WebSocketClient.prototype.on = function(eventName, handler) {
    this._eventLoop.on(eventName, handler);

    return this;
};

WebSocketClient.prototype.off = function(eventName, handler) {
    this._eventLoop.off(eventName, handler);

    return this;
};

WebSocketClient.prototype.trigger = function(eventName, data) {
    this._eventLoop.emit(eventName, data);

    return this;
};

WebSocketClient.prototype.setAPIKey = function(apiKey) {
    this._apiKey = apiKey;
};

WebSocketClient.prototype.send = function(event, details) {
    if (!this.isActive()) {
        const errorMessage = 'WebSocketClient.not_active';
        throw errorMessage;
    }

    this._ws.send(JSON.stringify({
        api_key : this._apiKey,
        event,
        details : details || null,
    }));
};

WebSocketClient.prototype.isActive = function() {
    return this._active && this._ws !== null;
};

WebSocketClient.prototype.connect = function() {
    this._ws = new WebSocket(this._url);

    this._ws.onopen    = this._onOpen.bind(this);
    this._ws.onclose   = this._onClose.bind(this);
    this._ws.onmessage = this._onMessage.bind(this);
};

WebSocketClient.prototype.cleanUp = function() {
    delete this._ws.onopen;
    delete this._ws.onclose;
    delete this._ws.onmessage;
    delete this._ws;
};

WebSocketClient.prototype.disconnect = function() {
    this._active = false;

    this._ws.close();
};

WebSocketClient.prototype.reconnect = function() {
    if (this._delay < 1) {
        return;
    }

    this.trigger('reconnect');

    this.cleanUp();
    this.connect();
};

WebSocketClient.prototype._onOpen = function() {
    this._delay = 0;

    this.trigger('open');
};

WebSocketClient.prototype._onClose = function() {
    if (!this._active) {
        this.trigger('close');

        return;
    }

    const actualDelay = Math.pow(2, ++this._delay);

    console.warn('Reconnecting in', actualDelay, 's ...');

    setTimeout(this.reconnect.bind(this), actualDelay * 1000);

    return;
};

WebSocketClient.prototype._onMessage = function(e) {
    if (!this.isActive()) {
        return;
    }

    const message = JSON.parse(e.data);

    this.trigger(message.event, message.details);

    if (this._handler) {
        this._handler(message);
    }
};

export default WebSocketClient;



// WEBPACK FOOTER //
// ./src/helpers/webSocketClient.tsx